<template>
  <div class="dialog-container dialog-light importSetup">
    <div class="dialog dialog-md">
      <!-- header import -->
      <ax-dialog-header
        text="Create a new Organisation"
        :type="'details'"
        :description="'Create a new organisation within Sinchii, or link your preexisting Xero organisation'"
      ></ax-dialog-header>
      <!-- select import step -->
      <div class="dialog-body">
        <!-- select import options screen -->
        <div class="import-group">
          <div>
            <div class="bubble white mb-2" id="sinchiiOption" @click="selectSinchiiOrgType" value="sinchiiOption" tabindex="-1" aria-disabled="true">
              <div class="inner">
                <div class="image">
                  <img src="../../assets/images/skip-icon.png" width="45">
                </div>
                <div class="description">
                  <h2 class="m-0">Sinchii Organisation</h2>
                  <p class="m-0">Create a new organisation</p>
                </div>
                <div class="icon">
                  <i class="icon-check"></i>
                </div>
              </div>
            </div>
            <div class="bubble white" id="serviceOption" @click="selectXeroOrgType" value="serviceOption" tabindex="-1" aria-disabled="true">
              <div class="inner">
                <div class="image">
                  <icon :type="'xero'" />
                </div>
                <div class="description">
                  <h2 class="m-0">Connect with Xero</h2>
                  <p class="m-0">Link organisation to Xero</p>
                </div>
                <div class="icon">
                  <i class="icon-check"></i>
                </div>
              </div>
            </div>
          </div>
          <div class="mt-5">
            <k-button variant="secondary" class="btn btn-lg btn-secondary w-100 mb-2" @click="onNext">
              Next
            </k-button>
            <k-button v-if="this.allowCancel" variant="secondary" class="btn btn-lg btn-outline-primary w-100" @click="onCancel">
              Cancel
            </k-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AuthService from "@/services/auth-service";
import icon from "../Icon.vue";
import { useToast } from "vue-toastification";

const toast = useToast();

export default({
  name: "organisation-set-up",
  components: {
    icon
  },
  props: {
    selectedOption: {
      default: null,
      type: Object
    },
    allowCancel: {
      default: true,
      type: Boolean
    }
  },
  data() {
    return {
      arrayOfImportOption: [
        "serviceOption",
        "sinchiiOption"
      ],
    }
  },
  mounted() {
    if (this.selectedOption && this.selectedOption.value) {
      this.manipulateOption(this.selectedOption.value);
    }
  },
  methods: {
    invalidImportSetup: function() {
      return !this.selectedOption || !this.selectedOption.value;
    },
    selectSinchiiOrgType() {
      this.manipulateOption("sinchii");
    },
    selectXeroOrgType() {
      this.manipulateOption("service");
    },
    manipulateOption(source) {
      if (!source) {
        return;
      }

      const sourceID = source + "Option";
      const option = document.getElementById(sourceID);
      
      this.arrayOfImportOption.forEach(option => {
        document.querySelector(`[value=${option}]`).classList.remove("selected");
      });

      option.classList.add("selected");
      this.selectedOption.value = source;
    },
    onNext() {
      if (this.invalidImportSetup()) {
        toast.clear();
        toast.error("Must select an option.");
      }
      else {
        switch(this.selectedOption.value) {
          case "sinchii":
            this.createSinchiiOrg();
            break;
          case "service":
            this.xeroRedirect();
            break;
        }
      }
    },
    createSinchiiOrg() {
      this.$emit("createSinchiiOrg");
    },
    xeroRedirect() {
      const scopes = "openid offline_access accounting.settings accounting.reports.read";
      AuthService.RedirectToXero(scopes);
    },
    onCancel() {
      this.$emit("onCancel");
    }
  }
})
</script>
